import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../store/state';
import { selectImage } from '../../store/action';
import { IFilterProductByCategoryDto } from '../../model/product.dto';
import { MobileDeviceService } from '../../../../mobile_device/service/mobile-device.service';
import { ProductService } from '../../services/product.service';

@Component({
  selector: 'app-creat-product',
  templateUrl: './creat-product.component.html',
  styleUrl: './creat-product.component.css'
})
export class CreatProductComponent {

  @Input() fg!: FormGroup;
  seletcProductCategory: IFilterProductByCategoryDto | undefined; // Produit sélectionné
  productCategories: IFilterProductByCategoryDto[] = [];

  // Si support sur un téléphone iu tablette
  isOnMobile: boolean = false;

  constructor(
    private _store: Store<IAppState>,
    private _mobileDeviceService: MobileDeviceService,
    private _productService: ProductService) {}


  ngOnInit() {
    this.isOnMobile = this._mobileDeviceService.isOnMobileDevice();
    this._productService.getProductCategories().subscribe(res=>{
      this.productCategories = res;
    });
  }
  /**
   *
   * @param file
   */
  selectImageEmit(file: File) {
    console.log("image" + file);
    if(file != null) {
      console.log(`[CreatProductComponent] ${file} `);
      this._store.dispatch(selectImage({ selectImage: file }));
    }
  }
}
